// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2vUxn","file":"styles_file__2sN_F"};